/* ORA INHALE — Cart Drawer */
window.OraCart = (function () {
  'use strict';

  const THRESHOLD  = 4000; // 40€ en centimes

  // IDs produits Ora Inhale (centimes)
  const SOLO_IDS = [15618177761605, 15739962458437, 15618175336773, 15739973435717];
  const DUO_IDS  = [15795913916741, 15796133036357, 15796133396805];

  // Mapping solo → upsell handle
  const UPSELL_MAP = {
    15618177761605: 'duo-zen',          // Sommeil
    15618175336773: 'duo-zen',          // Sérénité
    15739962458437: 'duo-performance',  // Clarté
    15739973435717: 'duo-performance',  // Vitalité
  };

  const panel   = document.getElementById('ora-cart-panel');
  const overlay = document.getElementById('ora-cart-overlay');

  if (!panel) return {};

  const itemsEl    = document.getElementById('ora-cart-items');
  const emptyEl    = document.getElementById('ora-cart-empty');
  const footerEl   = document.getElementById('ora-cart-footer');
  const totalEl    = document.getElementById('ora-cart-total');
  const progressEl = document.getElementById('ora-progress-fill');
  const progressTx = document.getElementById('ora-progress-text');
  const upsellEl   = document.getElementById('ora-cart-upsell');

  // ─── Open / Close ──────────────────────────────────────────
  function open() {
    fetchAndRender().then(() => {
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeBtn = document.getElementById('ora-cart-close');
      if (closeBtn) setTimeout(() => closeBtn.focus(), 320);
    });
  }

  function close() {
    panel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ─── Fetch & render ────────────────────────────────────────
  async function fetchAndRender() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      render(cart);
    } catch (e) {
      console.error('OraCart: fetch error', e);
    }
  }

  function render(cart) {
    updateProgress(cart.total_price);
    updateBadges(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.removeAttribute('hidden');
      footerEl.setAttribute('hidden', '');
      return;
    }

    emptyEl.setAttribute('hidden', '');
    footerEl.removeAttribute('hidden');

    // Items
    itemsEl.innerHTML = cart.items.map(renderItem).join('');
    itemsEl.querySelectorAll('[data-qty-change]').forEach((btn) => {
      btn.addEventListener('click', onQtyChange);
    });

    // Total
    totalEl.textContent = formatMoney(cart.total_price);

    // Upsell
    renderUpsell(cart);
  }

  function renderItem(item) {
    const img = item.image
      ? `<img src="${item.image}" alt="${item.title}" width="72" height="72" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span class="ora-cart-item__variant">${item.variant_title}</span>`
      : '';

    return `
      <div class="ora-cart-item" data-key="${item.key}" role="listitem">
        <div class="ora-cart-item__image">${img}</div>
        <div class="ora-cart-item__body">
          <span class="ora-cart-item__name">${item.product_title}</span>
          ${variant}
          <div class="ora-cart-item__row">
            <span class="ora-cart-item__price">${formatMoney(item.final_line_price)}</span>
            <div class="ora-cart-item__qty" role="group" aria-label="Quantité">
              <button class="ora-cart-item__qty-btn"
                      data-qty-change
                      data-key="${item.key}"
                      data-qty="${item.quantity - 1}"
                      aria-label="Réduire la quantité">−</button>
              <span class="ora-cart-item__qty-val">${item.quantity}</span>
              <button class="ora-cart-item__qty-btn"
                      data-qty-change
                      data-key="${item.key}"
                      data-qty="${item.quantity + 1}"
                      aria-label="Augmenter la quantité">+</button>
            </div>
          </div>
        </div>
      </div>`;
  }

  // ─── Quantité ──────────────────────────────────────────────
  async function onQtyChange(e) {
    const btn = e.currentTarget;
    const key = btn.dataset.key;
    const qty = parseInt(btn.dataset.qty, 10);
    btn.disabled = true;

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      const cart = await res.json();
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch {
      btn.disabled = false;
    }
  }

  // ─── Barre progression ─────────────────────────────────────
  function updateProgress(totalCents) {
    const pct = Math.min((totalCents / THRESHOLD) * 100, 100);
    progressEl.style.width = pct + '%';

    if (totalCents >= THRESHOLD) {
      progressTx.textContent = '🎉 Livraison offerte !';
      progressTx.classList.add('is-unlocked');
    } else {
      const remaining = formatMoney(THRESHOLD - totalCents);
      progressTx.innerHTML = `Plus que <strong>${remaining}</strong> pour la livraison offerte`;
      progressTx.classList.remove('is-unlocked');
    }
  }

  // ─── Upsell ────────────────────────────────────────────────
  function renderUpsell(cart) {
    const productIds = cart.items.map((i) => i.product_id);
    let upsellHandle = null;

    // Check si un duo est déjà dans le panier
    const hasDuo = productIds.some((id) => DUO_IDS.includes(id));

    if (!hasDuo) {
      // Chercher un solo dans le panier pour upsell duo
      for (const id of productIds) {
        if (UPSELL_MAP[id]) {
          upsellHandle = UPSELL_MAP[id];
          break;
        }
      }
      // Si pas de solo trouvé ou déjà un duo → coffret
      if (!upsellHandle) upsellHandle = 'coffret-ora-inhale';
    } else {
      // A un duo → proposer le coffret
      upsellHandle = 'coffret-ora-inhale';
    }

    // Vérifier que l'upsell n'est pas déjà dans le panier
    const tpl = document.getElementById(`upsell-tpl-${upsellHandle}`);
    if (!tpl) { upsellEl.setAttribute('hidden', ''); return; }

    const upsellProductId = parseInt(tpl.dataset.productId, 10);
    if (productIds.includes(upsellProductId)) {
      upsellEl.setAttribute('hidden', '');
      return;
    }

    // Cloner le template et l'injecter
    const clone = tpl.content.cloneNode(true);
    upsellEl.innerHTML = '';
    upsellEl.appendChild(clone);
    upsellEl.removeAttribute('hidden');

    // Bouton Ajouter
    const addBtn = upsellEl.querySelector('[data-variant-id]');
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        addBtn.textContent = '…';
        addBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: addBtn.dataset.variantId, quantity: 1 }),
          });
          const addedCart = await fetch('/cart.js').then((r) => r.json());
          render(addedCart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: addedCart }));
        } catch {
          addBtn.textContent = 'Ajouter';
          addBtn.disabled = false;
        }
      });
    }
  }

  // ─── Badges compteur ───────────────────────────────────────
  function updateBadges(count) {
    document.querySelectorAll('#ora-cart-count, #ora-bottom-cart-count').forEach((el) => {
      el.textContent = count;
      count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
    });
  }

  // ─── Helpers ───────────────────────────────────────────────
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  // ─── Event listeners ───────────────────────────────────────
  document.getElementById('ora-cart-close')?.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
  });

  // Intercepter les liens panier → ouvrir le drawer
  ['ora-cart-link', 'ora-bottom-cart'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        open();
      });
    }
  });

  // Écouter les ajouts au panier (depuis homepage et fiche produit)
  document.addEventListener('cart:updated', (e) => {
    if (e.detail) {
      updateBadges(e.detail.item_count);
      updateProgress(e.detail.total_price);
      if (panel.classList.contains('is-open')) render(e.detail);
      else open();
    }
  });

  return { open, close, fetchAndRender };
})();
